import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { AssignedGroupListType } from "../../../redux/userManagement/userManagementTypes";

type AppProps = {
  data: [] | AssignedGroupListType[];
  tableHeaders: TableHeadersType[];
};

const AssignedGroupTableData = ({
  data,
  tableHeaders,
}: AppProps) => {
  const renderTableData = () => {
    const finalTableData =
      data?.length > 0 &&
      data?.map((userGroupData: any) => {
        return (
          <tr key={userGroupData?.user_id}>
            {tableHeaders?.length > 0 &&
              tableHeaders?.map((item: TableHeadersType) => {
                if (item.value === "group_name") {
                  return (
                    <td className="text-center">{userGroupData?.group_name}</td>
                  );
                } else if (item.value === "user_name") {
                  return (
                    <td className="text-center">
                      {`${userGroupData?.first_name} ${userGroupData?.last_name} (${userGroupData?.email})`}
                      <br />
                    </td>
                  );
                }
              })}
          </tr>
        );
      });

    return finalTableData;
  };

  return <>{renderTableData()}</>;
};

export default AssignedGroupTableData;
